import React from 'react';
import { NavLink } from 'fluxible-router';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import NextStepsList from './NextStepsList';

const NextSteps = ({
  metadataNextSteps,
  sidebarArticlesNextSteps,
  platformTitle,
  isQuickstart
}) => (
  <div className={styles.nextSteps}>
    {metadataNextSteps && (
      <NextStepsList
        title="What can you do next?"
        items={metadataNextSteps}
        linkComponent="a"
        linkProps={{
          target: '_blank'
        }}
      />
    )}
    {(isQuickstart && sidebarArticlesNextSteps) && (
      <NextStepsList
        title={`More ${platformTitle} tutorials`}
        items={sidebarArticlesNextSteps}
        linkComponent={NavLink}
      />
    )}
  </div>
);

const stepsPropTypes = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    icon: PropTypes.number,
    href: PropTypes.string.isRequired
  })).isRequired,
  PropTypes.bool
]);

NextSteps.propTypes = {
  metadataNextSteps: stepsPropTypes,
  sidebarArticlesNextSteps: stepsPropTypes,
  platformTitle: PropTypes.string,
  isQuickstart: PropTypes.bool.isRequired
};

export default NextSteps;
